import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import call from "../../shared/services/api-service";
import { getFirstStringError } from "../../shared/utils/general.utils";
import { setUser } from "../../shared/services/auth-service";

const postCreateUnverifiedLead= createAsyncThunk("getStarted/postCreateUnverifiedLead", async(values:any): Promise<any>=>{
    try {
        var {onSuccessCallback, ...data} = values;
        const result = await call({
            path: `/api/v1/lead/uber/public`,
            method: "POST",
            data
        },"core");
        if(typeof onSuccessCallback === "function"){
            onSuccessCallback();
        }
        setUser({
            token: result.token,
            data:{
                role: result.token? "lead": "outer"
            }
        });
        return {captain_mobile: data.captain_mobile, result};
    } catch (error) {
        message.error(getFirstStringError(error));
        return;
    }
});

const fetchCities = createAsyncThunk("getStarted/fetchCities", async(): Promise<any>=>{
    let result: any = [];
    try {
        result = await call({
            path: `/api/v1/lead/uber/public/cities`,
            method: "GET",
        },"core");
        if(result){
            result = result.map((obj:any)=>(
                {
                    value: obj.id,
                    label: obj.name_ar
                }
            ));
        }
        return result;
    } catch (e) {
        message.error(getFirstStringError(e));
        return "error";
    }
});
async function fetchVehicleTypes(search_txt:any) {
    let result: any = {};
    try {
        result = await call({
            path: `/api/v1/lov/public/vehicle_types/sa`,
            method: "GET",
            data:{search_txt}
        },"config");
        if(result){
            result = result.map((obj:any)=>(
                {
                    value:obj.id,
                    label: obj.text
                }
            ));
            return result;
        }
    } catch (e) {
        return {
            isError: true,
            e
        };
    }
};
export {
    postCreateUnverifiedLead,
    fetchCities,
    fetchVehicleTypes
}